if ($('#pg_suppliers').length > 0) {

	$(".btn_menu_suppliers").addClass('active');
	$(".btn_menu_suppliers").closest('.dropdown').addClass('active');

	// CREATE SUPPLIER
		$('#btnCreateSupplierModal').on('click', function(e){
			e.stopPropagation();
			$('#createSupplierModal .modal-body').html('');
			ejecutar_ajax('/proveedores/crear', 'html', { _token: $(this).data('token') }, $(this), function(result) {
				$('#createSupplierModal .modal-body').html(result);
				$('#createSupplierModal').modal('show');
			});
			return false;
		});

		$('#createSupplierModal').on('shown.bs.modal', function () {
			$('#create_rtn').focus();
		});

		$('.btn_supplier_create').on('click', function(e) {
			e.stopPropagation();
			var btn = $(this);
			ejecutar_ajax('/proveedores/almacenar', 'html', $('#frm_suppliers_create').serialize(), btn, function(result) {
				$('#tbl_suppliers tbody').prepend(result);
				$('#tbl_suppliers tbody tr').each(function (index) {
					$(this).children('td').eq(0).text(index + 1);
				});
				$('.panel-footer small span').text($('#tbl_suppliers tbody tr').length);
				$('#createSupplierModal').modal('hide');
			});
			return false;
		});

	// EDIT SUPPLIER
		$(document).off('click', '.btnEditSupplierModal').on('click', '.btnEditSupplierModal', function(e){
			e.stopPropagation();
			var button = $(this);
			$('#editSupplierModal .modal-body').html('');
			ejecutar_ajax('/proveedores/' + button.data('supplier-id') + '/editar', 'html', { _token: button.data('token') }, button, function(result) {
				$('#editSupplierModal .modal-body').html(result);
				$('#editSupplierModal .modal-title .modal-title-name').text(button.data('name'));
				$('#editSupplierModal').modal('show');
			});
			return false;
		});

		$('#editSupplierModal').on('shown.bs.modal', function () {
			$('#edit_rtn').focus();
		});

		$('.btn_supplier_edit').on('click', function(e) {
			e.stopPropagation();
			ejecutar_ajax('/proveedores/' + $("#edit_supplier_id").val(), 'html', $('#frm_suppliers_edit').serialize(), $(this), function(result) {
				var row = $("#tbl_suppliers tbody").find("tr[data-supplier-id='" + $('#edit_supplier_id').val() + "']");
				row.html(result).addClass('warning');
				$('#tbl_suppliers tbody tr').each(function (index) {
					$(this).children('td').eq(0).text(index + 1);
				});
				$('#editSupplierModal').modal('hide');
			});
			return false;
		});

	// DELETE SUPPLIER
		$('#deleteSupplierModal').on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget); // Button that triggered the modal
			$("#deleteSupplierModal .modal-body span").text(button.data('name'));
			$('#btn_suppliers_delete').data('supplier-id', button.data('supplier-id'));
		});

		$('#btn_suppliers_delete').on('click', function(e) {
			e.stopPropagation();
			var supplier_id = $(this).data('supplier-id');
			var datos = {
				_token: $(this).data('token'),
				_method: 'DELETE'
			}
			ejecutar_ajax('/proveedores/' + supplier_id, 'json', datos, $(this), function(result) {
				if (result == 1) {
					$("#tbl_suppliers tbody").find("tr[data-supplier-id='" + supplier_id + "']").remove();
					$('.panel-footer small span').text($('#tbl_suppliers tbody tr').length);
					$('#deleteSupplierModal').modal('hide');
					//flash_message('atencion', 'La cotización fue eliminada satisfactoriamente.');
				}
			});
			return false;
		});

	// SEARCH SUPPLIERS
		$("#txt_suppliers_search").keyup(function(e){
			if (e.keyCode == 27) {
				$(this).val('');
			}
			search_box('tbl_suppliers', $(this), 5);
		});

}
